export const MENU_PATHS = [
  { icon: 'bi-speedometer2', label: 'Panel de Control', url: '/', enabled: true },
  { icon: 'bi-wallet2', label: 'Gastos', enabled: false },
  { icon: 'bi-journal-bookmark', label: 'Libros', enabled: false },
  { icon: 'bi-truck', label: 'Proveedores', url: '/proveedores', enabled: true },
  { icon: 'bi-people', label: 'Empleados', url: '/empleados', enabled: true },
  {
    icon: 'bi-receipt',
    label: 'Retenciones',
    enabled: true,
    submenu: [
      {
        icon: 'bi-percent',
        label: 'I.V.A. Impuesto Al Valor Agregado',
        url: '/retenciones/iva',
        enabled: true
      },
      {
        icon: 'bi-cash-stack',
        label: 'I.S.L.R. Impuesto Sobre La Renta',
        url: '/retenciones/islr',
        enabled: true
      },
      {
        icon: 'bi-person-badge',
        label: 'I.S.L.R. Retención a Empleados',
        url: '/retenciones/islr-empleados',
        enabled: true
      },
      {
        icon: 'bi-calculator',
        label: 'Otros Impuestos',
        url: '/retenciones/otros',
        enabled: true
      },
    ],
  },
  { icon: 'bi-folder', label: 'Archivo', enabled: false },
  { icon: 'bi-clock-history', label: 'Histórico', enabled: false },
  { icon: 'bi-bar-chart', label: 'Reportes', enabled: false },
];